window.Cookies = require("js-cookie");
require('./global/global');
require('./global/hegyd');
require('./global/cnil');
require('./global/share');